import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=66c401c3&scoped=true&"
import script from "./ShopItem.vue?vue&type=script&lang=js&"
export * from "./ShopItem.vue?vue&type=script&lang=js&"
import style0 from "./ShopItem.vue?vue&type=style&index=0&id=66c401c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c401c3",
  null
  
)

export default component.exports